import * as t from 'io-ts';
import { authorizedTo, id, links, meta } from '@/services/api';
import { COURSE_TYPE } from '@/entities/trainings';

export const courseReportItemCodec = t.type({
  id,
  type: t.keyof({
    [COURSE_TYPE.SECTION]: null,
    [COURSE_TYPE.TEXT]: null,
    [COURSE_TYPE.VIDEO]: null,
    [COURSE_TYPE.IMAGE]: null,
    [COURSE_TYPE.QUIZ]: null,
  }),
  title: t.string,
  position: t.number,
  section_id: t.union([id, t.null]),
});

export const courseReportSectionCodec = t.intersection([
  courseReportItemCodec,
  t.type({
    type: t.literal(COURSE_TYPE.SECTION),
    section_id: t.null,
    items: t.array(courseReportItemCodec),
  }),
]);

export const courseReportCodec = t.type({
  id,
  title: t.string,
  deadline: t.union([t.number, t.null]),
  completed_at: t.number,
  score: t.union([t.number, t.null]),
  passed: t.union([t.boolean, t.null]),
  user: t.type({
    id: t.number,
    name: t.string,
  }),
});

export const courseReportDetailCodec = t.intersection([
  courseReportCodec,
  t.type({
    items: t.array(t.union([courseReportSectionCodec, courseReportItemCodec])),
  }),
]);

export const reportAuthorizedCodec = t.intersection([
  courseReportCodec,
  t.type({
    authorizedTo,
  }),
]);

export const courseReportsListCodec = t.type({
  data: t.array(reportAuthorizedCodec),
  meta,
  links,
});
